import Product from '../product';
import Material from '../../material/material';
import StandardStickerPart from './standard-sticker-part';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import WindowstickerMaterialAware from './windowsticker-material-aware';
import TilingAware from '../../helper-interfaces/tiling-aware';

export default class Windowsticker extends Product
  implements WindowstickerMaterialAware, TilingAware {
  coverWindowColumn = false;
  temporaryMaterial = true;
  foil?: Material;
  laminate?: Material;
  windowWidth?: number;
  windowLength?: number;
  tiling?: boolean;
  numTilingHorizontal?: number;
  numTilingVertical?: number;
  numPandOk?: boolean;
  standardStickerParts?: StandardStickerPart[];

  constructor() {
    super();
    this.type = 'WindowSticker';
  }

  // Override
  public canSubmitAsClient(): boolean {
    return (
      CollectionHelper.isPopulated(this.standardStickerParts) &&
      this.standardStickerParts.every(ssp => ssp.canSubmitAsClient())
    );
  }
}

export const FoilChoices = {
  // Temporary
  MONOMER: new Material('Monomeer (2 jaar)', 0),
  RAPID_AIR: new Material('Rapid air (Bubbel-folie)', 1),
  TRUE_VISION_TEMPORARY: new Material('True vision (Doorkijkfolie)', 2),
  TRANSPARENT_FOIL_TEMPORARY: new Material(
    'Transparante folie (witte inkt - langs binnen kleven)',
    3
  ),
  // Permanent
  POLYMER: new Material('Polymeer (4/5 jaar)', 4),
  CAST_FOIL: new Material('Cast folie (3M)', 5),
  TRUE_VISION_PERMANENT: new Material('True vision (Doorkijkfolie)', 6),
  TRANSPARENT_FOIL_PERMANENT: new Material(
    'Transparante folie (witte inkt - langs binnen kleven)',
    7
  ),
  ADHESIVE_LETTERS: new Material('Kleefletters', 13),
  SANDBLAST_FOIL: new Material('Zandstraalfolie', 14)
};

export const LaminateChoices = {
  TEMPORARY_GLOSSY: new Material('Laminaat blinkend', 8),
  TEMPORARY_MATTE: new Material('Laminaat mat', 9),
  PERMANENT_GLOSSY: new Material('Laminaat blinkend', 10),
  PERMANENT_MATTE: new Material('Laminaat mat', 11),
  NO_LAMINATE: new Material('Geen laminaat', 12)
};

export const TemporaryMaterialChoices = {
  TEMPORARY: {
    label: 'Tijdelijk',
    value: true,
    foilChoices: [
      FoilChoices.MONOMER,
      FoilChoices.RAPID_AIR,
      FoilChoices.TRUE_VISION_TEMPORARY,
      FoilChoices.TRANSPARENT_FOIL_TEMPORARY
    ],
    laminateChoices: [
      LaminateChoices.TEMPORARY_GLOSSY,
      LaminateChoices.TEMPORARY_MATTE,
      LaminateChoices.NO_LAMINATE
    ]
  },
  PERMANENT: {
    label: 'Permanent',
    value: false,
    foilChoices: [
      FoilChoices.POLYMER,
      FoilChoices.CAST_FOIL,
      FoilChoices.TRUE_VISION_PERMANENT,
      FoilChoices.TRANSPARENT_FOIL_PERMANENT,
      FoilChoices.ADHESIVE_LETTERS,
      FoilChoices.SANDBLAST_FOIL
    ],
    laminateChoices: [
      LaminateChoices.PERMANENT_GLOSSY,
      LaminateChoices.PERMANENT_MATTE,
      LaminateChoices.NO_LAMINATE
    ]
  }
};
